import React, { useState, useContext, Fragment } from 'react';
import { array, number } from 'prop-types';
import classNames from 'classnames/bind';
import qs from 'qs';

import LinkedArticlesTable from '../LinkedArticlesTable';
import SelectLinkedBrand from './components/SelectLinkedBrand';

import { withArticleLinkedManufactures } from 'containers/withArticleLinkedManufactures';
import { withErrorBoundary } from 'containers/ErrorBoundary';
import { withLabels } from 'containers/withLabels';

import { ProductTabsContext } from 'context/ProductTabsContext';

import styles from './TabLinkedVehicles.module.scss';
const cx = classNames.bind(styles);

const TabLinkedVehicles = ({ productId, data, labels }) => {
  const [manuLinkedId, setManuLinkedId] = useState(null);
  const { linkedVehiclesTab } = useContext(ProductTabsContext);

  const queryValues = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  return (
    <div className={cx('tab-content')}>
      {!linkedVehiclesTab && (
        <p className={cx('empty-content')}>{labels.emptyLinkedVehicles}</p>
      )}
      {!!linkedVehiclesTab && !!linkedVehiclesTab.array && (
        <SelectLinkedBrand
          setManuLinkedId={setManuLinkedId}
          brands={linkedVehiclesTab.array}
        />
      )}

      <div id="oe-numbers">
        {!!manuLinkedId && !!productId && (
          <Fragment>
            <LinkedArticlesTable
              productId={productId}
              manuLinkedId={manuLinkedId}
              modId={queryValues.modId}
            />
          </Fragment>
        )}
      </div>
    </div>
  );
};

TabLinkedVehicles.propTypes = {
  dataOeNumbers: array.isRequired,
  productId: number.isRequired,
};

export default withLabels(
  withArticleLinkedManufactures(withErrorBoundary(TabLinkedVehicles))
);



// WEBPACK FOOTER //
// ./src/pages/Product/components/TabLinkedVehicles/TabLinkedVehicles.js